package ir.yusefpasha.sections

import Header
import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.components.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import ir.yusefpasha.components.SocialBar
import ir.yusefpasha.models.Section
import ir.yusefpasha.models.Theme
import ir.yusefpasha.style.MainButtonStyle
import ir.yusefpasha.style.MainImageStyle
import ir.yusefpasha.util.Constants
import ir.yusefpasha.util.Res
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun MainSection(onMenuClicked: () -> Unit) {
    val breakpoint = rememberBreakpoint()
    Box(
        modifier = Modifier
            .id(Section.Home.id)
            .maxWidth(Constants.SECTION_WIDTH.px)
    ) {
        MainBackground()
        MainContent(breakpoint, onMenuClicked)
    }
}

@Composable
private fun MainBackground() {
    Image(
        src = Res.Image.BACKGROUND,
        desc = "Background Image",
        modifier = Modifier.fillMaxSize().objectFit(ObjectFit.Cover)
    )
}

@Composable
private fun MainContent(breakpoint: Breakpoint, onMenuClicked: () -> Unit) {
    Column(
        modifier = Modifier.fillMaxSize(),
        verticalArrangement = Arrangement.SpaceBetween,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Header(onMenuClicked)
        Column(
            modifier = Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.Bottom,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SimpleGrid(
                modifier = Modifier.fillMaxWidth(
                    if (breakpoint >= Breakpoint.MD) 80.percent else 90.percent
                ),
                numColumns = numColumns(base = 1, sm = 1, md = 2)
            ) {
                MainText(breakpoint)
                MainImage(breakpoint)
            }
        }
    }
}

@Composable
private fun MainText(breakpoint: Breakpoint) {
    Row(
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ) {
        if (breakpoint > Breakpoint.MD) {
            SocialBar()
        }
        Column {
            P(
                attrs = Modifier
                    .margin(top = 0.px, bottom = 0.px)
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(if (breakpoint >= Breakpoint.LG) 42.px else 20.px)
                    .fontWeight(FontWeight.Normal)
                    .color(
                        if (breakpoint >= Breakpoint.MD) Theme.Primary.rgb
                        else Theme.Secondary.rgb
                    )
                    .toAttrs()
            ) {
                Text("Hello, I`m")
            }

            P(
                attrs = Modifier
                    .margin(top = 0.px, bottom = 0.px)
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(if (breakpoint >= Breakpoint.LG) 60.px else 35.px)
                    .fontWeight(FontWeight.Bolder)
                    .color(Theme.Secondary.rgb)
                    .toAttrs()
            ) {
                Text("Yusef Pasha")
            }

            P(
                attrs = Modifier
                    .margin(top = 10.px, bottom = 5.px)
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(if (breakpoint >= Breakpoint.LG) 20.px else 15.px)
                    .fontWeight(FontWeight.Bold)
                    .color(Theme.Secondary.rgb)
                    .toAttrs()
            ) {
                Text("Android / Kotlin Developer :)")
            }

            P(
                attrs = Modifier
                    .margin(bottom = 20.px)
                    .maxWidth(400.px)
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(if (breakpoint >= Breakpoint.LG) 16.px else 10.px)
                    .lineHeight(1.5)
                    .fontStyle(FontStyle.Italic)
                    .fontWeight(FontWeight.Normal)
                    .color(Theme.Secondary.rgb)
                    .toAttrs()
            ) {
                Text(
                    """
                    As a Kotlin developer, I worked with most Kotlin libraries and frameworks, including: JP-Compose, Ktor-Server, Ktor-Client, Koin, Ktorm, Kmongo, Kobweb, Kvision, Ksoup-Jsoup and... .
                """.trimIndent()
                )
                Text(
                    """
                    Currently my focus is on Kotlin Multi-Platform (KMP) and Android + New UI Toolkit, JetPack Compose.
                """.trimIndent()
                )
                Text(
                    """
                    My field of expertise is Android and it has been about three years since I implemented various projects in this field
                """.trimIndent()
                )
            }

            Button(
                attrs = MainButtonStyle.toModifier()
                    .height(40.px)
                    .border(0.px)
                    .margin(
                        bottom = if (breakpoint >= Breakpoint.MD) 0.px else 40.px
                    )
                    .borderRadius(r = 20.px)
                    .backgroundColor(Theme.Primary.rgb)
                    .color(Colors.White)
                    .cursor(Cursor.Pointer)
                    .toAttrs()
            ) {
                Link(
                    modifier = Modifier
                        .color(Colors.White)
                        .textDecorationLine(TextDecorationLine.None),
                    text = "Hire Me",
                    path = Section.Contact.path
                )
            }
        }
    }
}

@Composable
private fun MainImage(breakpoint: Breakpoint) {
    Box(
        modifier = Modifier.fillMaxHeight(),
        contentAlignment = Alignment.BottomCenter
    ) {
        Image(
            modifier = MainImageStyle.toModifier()
                .fillMaxWidth(if (breakpoint >= Breakpoint.MD) 70.percent else 0.percent)
                .fillMaxHeight(),
            src = Res.Image.PROFILE,
            desc = "My Profile"
        )
    }
}